import React, { LegacyRef } from 'react';
import { Button } from 'reactstrap';
import fallback from '../../../_Translations/generated/camper-search.en.t.json';
import Keys from '../../../_Translations/generated/camper-search.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';

interface TravelerSelectProps {
  toggleDropdown?: () => void;
  adults: number;
  children: number;
}

interface DropdownProps extends TravelerSelectProps {
  ref: LegacyRef<HTMLDivElement>;
  handleAdultChange: (arg: boolean) => void;
  handleChildrenChange: (arg: boolean) => void;
}

export const TravelerSelectionDropdown = ({
  adults,
  children,
  handleAdultChange,
  handleChildrenChange
}: DropdownProps) => {
  const { t } = useTranslation('camper-search', fallback, Keys);

  return (
    <div className="traveler-selection__dropdown">
      <div className="traveler-selection__dropdown__traveler-count">
        <span>{t(Keys.adults)}</span>
        <div className="traveler-selection__dropdown__traveler-count__wrapper">
          <button
            type="button"
            className="traveler-selection__dropdown__traveler-count__btn"
            onClick={() => handleAdultChange(false)}
          >
            -
          </button>
          <span>{adults}</span>
          <button
            type="button"
            className="traveler-selection__dropdown__traveler-count__btn"
            onClick={() => handleAdultChange(true)}
          >
            +
          </button>
        </div>
      </div>
      <div className="traveler-selection__dropdown__traveler-count">
        <span>{t(Keys.children)}</span>
        <div className="traveler-selection__dropdown__traveler-count__wrapper">
          <button
            type="button"
            className="traveler-selection__dropdown__traveler-count__btn"
            onClick={() => handleChildrenChange(false)}
          >
            -
          </button>
          <span>{children}</span>
          <button
            type="button"
            className="traveler-selection__dropdown__traveler-count__btn"
            onClick={() => handleChildrenChange(true)}
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
};

export const TravelerSelection = ({ toggleDropdown, adults, children }: TravelerSelectProps) => {
  const { t } = useTranslation('camper-search', fallback, Keys);

  return (
    <div className="traveler-selection">
      <div className="traveler-selection-wrapper">
        <Button
          className="traveler-selection-input custom-button btn btn-white"
          color="white"
          onClick={toggleDropdown}
        >
          <div className="w-100 traveler-selection-input_text-container">
            <span>
              {adults + children}{' '}
              {adults + children === 1 ? `${t(Keys.traveler)}` : `${t(Keys.travelers)}`}
            </span>
          </div>
        </Button>
      </div>
    </div>
  );
};
